<!--
  -  Copyright (c) Qwoach LLC 2020. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 20/12/2020
  -->

<template>
	<qw-button
		size="small"
		type="danger"
		v-bind="listenersComputed">
		<slot></slot>
	</qw-button>
</template>

<script>

import QwBaseButton from "@/core/components/Controls/Buttons/QwBaseButton.vue";

export default {
	name: "QwButtonDanger",
	extends: QwBaseButton,
}
</script>

<style lang="scss">

</style>
